<template>
  <div class="content">
    <div class="authtips" v-if="pageName == pageEnum.experience">
      <div style="padding-top: 1rem"></div>
      <div class="b1">
        <img
          src="https://assets.rurushishi.com/yq-rs-make/qywx/kefu2.png"
          alt=""
        />
        <div>原圈官方客服</div>
      </div>
      <div class="b2">
        <div class="b2txt0">由于产品需进行后台配置方可使用</div>
        <div class="b2txt1">
          <!-- 请管理员联系<span>原圈官方客服</span>开通授权应用 -->
          请扫码添加客服
        </div>
        <div class="b2txt2">工作时间：工作日周一至周五 9:00～18:00</div>
      </div>

      <div class="b3">
        官方客服电话：<a :href="'tel:' + tipsPhone">{{ tipsPhone }}</a>
      </div>
      <div class="b4">
        <div class="b4btn1" @click="clickExperience">体验演示环境</div>
      </div>
    </div>
    <div v-else-if="pageName == pageEnum.selectGzh" class="selectgzh">
      <img
        src="https://assets.rurushishi.com/yq-rs-make/qywx/yq-logo.png"
        alt=""
      />
      <Multiselect
        class="select"
        v-model="appDetailInfoListSelected"
        :options="appDetailInfo"
        placeholder="选择服务号"
        :searchable="false"
        :allow-empty="false"
        :show-labels="false"
        track-by="appName"
        label="appName"
      >
        <template slot="singleLabel" slot-scope="{ option }">{{
          option.appName
        }}</template>
      </Multiselect>

      <div
        class="next"
        :class="{ nextBlue: appDetailInfoListSelected }"
        @click="clickNext"
      >
        下一步
      </div>
    </div>
    <div v-else-if="pageName == pageEnum.selectWx" class="selectWx step-container">
      <div class="bind-icon">
        <img src="https://assets.rurushishi.com/yq-rs-make/qwauth/bind-icon.png">
      </div>
      <div class="bind-btn" @click="clickSelectWxGoWxBind">绑定</div>
      <div class="bottom-text">若想使用微信分身绑定企微，<span @click="clickSelectWxGoWxNext">请点击查看</span></div>
    </div>
    <div v-else-if="pageName == pageEnum.anotherWx" class="anotherWx step-anotherWx-container">
      <!-- <div class="b2">绑定微信分身</div> -->
      <div class="b3">
        <div class="title">
          <div class="left">绑定微信分身</div>
          <div class="right" @click="clickAnotherWxIntro">点击查看图片说明</div>
        </div>
        <div class="txt1">
          请复制下方内容，到微信分身里的任意1个聊天框(建议是文件传输助手）发送，并且把2个链接都手动点击
        </div>
        <div class="txt2" id="target">
          {{ anotherWxCopyTxt }}
        </div>
      </div>
      <div
        class="copytxt"
        @click="clickAnotherWxCopyTxt"
        id="copyBtn"
        data-clipboard-action="copy"
        data-clipboard-target="#target"
      >
        复制文字
      </div>
    </div>
    <div v-else class="loading">{{ loading }}</div>
    <div class="auth-fail" v-if="isAuthFail">
      <div class="fail-tip">非常抱歉，因为授权失败，无法进入工作台！</div>
      <img src="https://assets.rurushishi.com/yq-rs-make/qywx/auth_fail.png" alt="" class="fail-img">
      <div class="line"></div>
      <p class="fail-desc">请检查应用首页里的corpid是否正确</p>
    </div>
  </div>
</template>

<script>
import util from "../../utils/utils";
import * as api from "./qywxApi";
import Cookies from "js-cookie";
import qywxConst from "./const";
import Multiselect from "vue-multiselect";
import wxsdk from "@/utils/wxsdk";
import Clipboard from "clipboard";
const wx = window.jWeixin;
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      loading: "加载中...",
      tipsPhone: "021-68388750",
      tipsQrcode: "https://assets.rurushishi.com/rs/qr_qmyx_6006.jpg",
      testDomain: "qywx.ruthus.com",
      prodDomain: "qyweb.gbtse.com",
      appInfo: null,
      appDetailInfoListSelected: null,
      cookieKeyBeforeLogin: "",
      wxAuthSubDomain: "",
      pageName: "",
      pageEnum: {
        experience: "experience", //体验版
        selectGzh: "selectGzh", //选择公众号
        selectWx: "selectWx", //选择微信
        anotherWx: "anotherWx", //微信分身
        other: "", //其它
      },
      goWxAuthUrl: "",
      anotherWxCopyTxt: "",
      cookieKeys: {
        openid: "openid",
        passport: "passport",
        appMark: "appMark",
        appType: "appType",
        corpId: "corpId",
        gzhSubDomain: "gzhSubDomain",
        gzhAppId: "gzhAppId",
        gzhDomain: "gzhDomain",
        qwUserId: "qwUserId",
        wxworkUserId: "wxworkUserId",
      },
      cookieExpires: 60 * 24 * 365, //分钟
      appDetailInfo: [],
      isAuthFail: false
    };
  },
  methods: {
    clickExperience() {
      if (this.$route.query.appMark == "magicbox") {
        if (location.host.indexOf(this.testDomain) > -1) {
          location.href =
            "https://qywx.ruthus.com/qwmagicbox/pages/index/index?openid=oj3y9wAW8G9xaVFEwFPoL8Zf_b-s&passport=7a3ca356da121d388fc612ac9f423ed9&appMark=crm&corpId=wwed9dac1a999baeac&qwUserId=woO3ZZCAAAACBdVGih_yrg6y3UeOcrmQ&gzhSubDomain=qmyx&gzhDomain=qmyx.putzip.com&enterType=2";
        } else {
          location.href =
            "https://qyweb.gbtse.com/qwmagicbox/pages/index/index?openid=oPg9r1XZnmnj8mOT0Ns0wSWgHH94&passport=ffc0903abd9bae4ae22322ed34228639&appMark=crm&corpId=ww0eaa71bdd8b2e88b&qwUserId=woO3ZZCAAA2zdnBJgLhB7X7d0zqgqXOQ&gzhSubDomain=yqjisu&gzhDomain=yqjisu.rushizhineng.com&enterType=2";
        }
      } else {
        if (location.host.indexOf(this.testDomain) > -1) {
          location.href =
            "https://qywx.ruthus.com/marketies/qwdesk/pages/index/sale?openid=oj3y9wAW8G9xaVFEwFPoL8Zf_b-s&passport=7a3ca356da121d388fc612ac9f423ed9&appMark=crm&corpId=wwed9dac1a999baeac&qwUserId=woO3ZZCAAAACBdVGih_yrg6y3UeOcrmQ&gzhSubDomain=qmyx&gzhAppId=wx01f0b018d4951434&gzhDomain=qmyx.putzip.com";
        } else {
          location.href =
            "https://qyweb.gbtse.com/marketies/qwdesk/pages/index/sale?openid=oPg9r1XZnmnj8mOT0Ns0wSWgHH94&passport=ffc0903abd9bae4ae22322ed34228639&appMark=crm&corpId=ww0eaa71bdd8b2e88b&qwUserId=woO3ZZCAAA2zdnBJgLhB7X7d0zqgqXOQ&gzhSubDomain=yqjisu&gzhAppId=wxc032f5bc8eb14ebc&gzhDomain=yqjisu.rushizhineng.com";
        }
      }
    },
    clickNext() {
      if (!this.appDetailInfoListSelected) return;
      this.bindUserGzhInfo();
    },
    bindUserGzhInfo() {
      // 获取用户信息
      let postObj = {
        account: this.appInfo.userId,
        corpId: this.appInfo.corpId,
        appid: this.appDetailInfoListSelected.appId,
        accountType: "qywx"
      };
      api.getUserByAccount(postObj).then((res) => {
        console.log("getUserByAccount", res);
        // this.$yqAnalytics.clientLog('getUserByAccount',{
        //   appInfo:this.appInfo,
        //   res
        // })
        if (res.code === 0) {
          let gzhAppId = this.appDetailInfoListSelected.appId;
          let gzhSubDomain = this.appDetailInfoListSelected.domain;
          // 从应用配置的url拿授权后要打开的链接，这里是微信对应的链接
          // 下周替回
          let url = this.appDetailInfoListSelected.url;
          // let filterList = this.appInfo.appDetailInfo.filter(item => item.appId === this.appDetailInfoListSelected.appId);
          // let url = '';
          // if (filterList && filterList.length) {
          //   url = filterList[0].url;
          // }
          // 把配置的url替换成企微环境的
          let gzhDomain = util.getHostFromUrl(
            this.appDetailInfoListSelected.url
          );

          if (
            gzhDomain.indexOf("qmyx.") > -1 ||
            gzhDomain.indexOf("sjzstest.") > -1 ||
            gzhDomain.indexOf("rstest.") > -1 ||
            gzhDomain.indexOf("cartest.") > -1
          ) {
            // 测试环境
            url = url.replace(gzhDomain, this.testDomain);
          } else {
            // 生产环境
            url = url.replace(gzhDomain, this.prodDomain);
          }

          let beforeLoginUrl = "";
          let beforeLoginUrlParam = null;
          if (Cookies.get(this.cookieKeyBeforeLogin)) {
            beforeLoginUrl = decodeURIComponent(
              Cookies.get(this.cookieKeyBeforeLogin)
            );
            beforeLoginUrlParam = util.getParamFromUrl(beforeLoginUrl);
            if (beforeLoginUrlParam.url) {
              // 如果之前存的有回调链接则用之前存的回调链接
              url = decodeURIComponent(beforeLoginUrlParam.url);
            } else {
              Cookies.set(
                this.cookieKeyBeforeLogin,
                encodeURIComponent(
                  util.addUrlParamFromObj(beforeLoginUrl, {
                    url: encodeURIComponent(url),
                  })
                ),
                this.cookieExpires
              );
            }
          }
          // if (this.appInfo.appType == 0) {
          //   // 如果是自建应用不用去判断是否绑定了微信，直接带上企微的相关用户信息返回
          //   let urlOldParam = util.getParamFromUrl(url);
          //   if (urlOldParam.appMark) delete urlOldParam.appMark;
          //   if (urlOldParam.hasOwnProperty(urlOldParam.appType))
          //     delete urlOldParam.appType;
          //   if (urlOldParam.corpId) delete urlOldParam.corpId;
          //   if (urlOldParam.qwUserId) delete urlOldParam.qwUserId;
          //   let urlParam = {
          //     appMark: qywxConst.appMark, //企业微信应用标识
          //     appType: this.appInfo.appType, //应用类型：自建 or 第三方
          //     corpId: this.appInfo.corpId, //企业id
          //     // qwUserId: this.appInfo.openUserId, //企业微信用户id
          //     wxworkUserId: this.appInfo.userId,
          //     ...urlOldParam,
          //   };
          //   url = util.addUrlParamFromObj(
          //     util.getUrlRemoveParams(url),
          //     urlParam
          //   );
          //   location.href = url;
          // } else {
          // }

          // 第三方应用
          if (
            res.data &&
            res.data.openid &&
            res.data.passport &&
            !(beforeLoginUrlParam && beforeLoginUrlParam.wxaction)
          ) {
            // 有用户信息 带上openid和passport 跳转到返回的售楼中心链接并替换成企微版的路径

            Cookies.set(this.cookieKeys.openid, res.data.openid, {
              expires: this.cookieExpires,
            });
            Cookies.set(this.cookieKeys.passport, res.data.passport, {
              expires: this.cookieExpires,
            });
            Cookies.set(this.cookieKeys.appMark, qywxConst.appMark, {
              expires: this.cookieExpires,
            });
            Cookies.set(this.cookieKeys.appType, this.appInfo.appType, {
              expires: this.cookieExpires,
            });
            Cookies.set(this.cookieKeys.corpId, this.appInfo.corpId, {
              expires: this.cookieExpires,
            });
            Cookies.set(this.cookieKeys.gzhSubDomain, gzhSubDomain, {
              expires: this.cookieExpires,
            });
            Cookies.set(this.cookieKeys.gzhAppId, gzhAppId, {
              expires: this.cookieExpires,
            });
            Cookies.set(this.cookieKeys.gzhDomain, gzhDomain, {
              expires: this.cookieExpires,
            });
            // Cookies.set(this.cookieKeys.qwUserId, this.appInfo.openUserId, {
            //   expires: this.cookieExpires,
            // });
            Cookies.set(this.cookieKeys.wxworkUserId, this.appInfo.userId, {
              expires: this.cookieExpires,
            });

            // 如果有解绑参数
            if (this.$route.query.action == "unbundling") {
              api
                .accountUnbind({
                  account: this.appInfo.userId,
                  corpId: this.appInfo.corpId,
                })
                .then((res) => {
                  console.log("解绑微信");
                  if (this.global.isLoc) {
                  } else {
                    Cookies.remove(this.cookieKeys.openid);
                    Cookies.remove(this.cookieKeys.passport);
                    Cookies.remove(this.cookieKeys.appMark);
                    Cookies.remove(this.cookieKeys.appType);
                    Cookies.remove(this.cookieKeys.corpId);
                    Cookies.remove(this.cookieKeys.gzhSubDomain);
                    Cookies.remove(this.cookieKeys.gzhAppId);
                    Cookies.remove(this.cookieKeys.gzhDomain);
                    Cookies.remove(this.cookieKeys.qwUserId);
                    Cookies.remove(this.cookieKeys.wxworkUserId);
                    localStorage.clear();
                    let url = `https://${location.host}/qwh5/qywx/index?appMark=${qywxConst.appMark}`;
                    location.href = url;
                  }
                });
              return;
            }

            let urlOldParam = util.getParamFromUrl(url);
            if (urlOldParam.openid) delete urlOldParam.openid;
            if (urlOldParam.passport) delete urlOldParam.passport;
            if (urlOldParam.appMark) delete urlOldParam.appMark;
            if (urlOldParam.hasOwnProperty(urlOldParam.appType))
              delete urlOldParam.appType;
            if (urlOldParam.corpId) delete urlOldParam.corpId;
            if (urlOldParam.qwUserId) delete urlOldParam.qwUserId;
            if (urlOldParam.gzhSubDomain) delete urlOldParam.gzhSubDomain;
            if (urlOldParam.gzhAppId) delete urlOldParam.gzhAppId;
            if (urlOldParam.gzhDomain) delete urlOldParam.gzhDomain;
            let urlParam = {
              openid: res.data.openid,
              passport: res.data.passport,
              appMark: qywxConst.appMark, //企业微信应用标识
              appType: this.appInfo.appType, //应用类型：自建 or 第三方
              corpId: this.appInfo.corpId, //企业id
              // qwUserId: this.appInfo.openUserId, //企业微信用户id
              wxworkUserId: this.appInfo.userId,
              gzhSubDomain: gzhSubDomain,
              gzhAppId: gzhAppId,
              gzhDomain: gzhDomain,
              ...urlOldParam,
            };
            url = util.addUrlParamFromObj(
              util.getUrlRemoveParams(url),
              urlParam
            );
            /**
             * 此链接是要在企微打开的所以只能是企微的两个域名。qywx.ruthus.com 和 qyweb.gbtse.com
             * 如果不是此域名是qmyx.或cartest.开头的域名就是测试的，否则是生产的
             */
            let urlDomain = url.split("/")[2];
            if (
              !(urlDomain == this.testDomain || urlDomain == this.prodDomain)
            ) {
              if (
                urlDomain.startsWith("qmyx.") ||
                urlDomain.startsWith("sjzstest.") ||
                urlDomain.startsWith("rstest.") ||
                urlDomain.startsWith("cartest.")
              ) {
                url = url.replace(urlDomain, this.testDomain);
              } else {
                url = url.replace(urlDomain, this.prodDomain);
              }
            }

            if (this.global.isLoc) {
              console.log("绑定过的用户,将会打开", url);
            } else {
              location.href = url;
            }
          } else {
            Cookies.set(this.cookieKeys.appMark, qywxConst.appMark, {
              expires: this.cookieExpires,
            });
            Cookies.set(this.cookieKeys.corpId, this.appInfo.corpId, {
              expires: this.cookieExpires,
            });
            if (beforeLoginUrlParam && beforeLoginUrlParam.wxaction) {
              // 特定动作去微信关注
              url = `${location.protocol}//${util.getHostFromUrl(
                this.appDetailInfoListSelected.url
              )}/h5/qywx/wxaction`;
              let urlParam = {
                // account: this.appInfo.openUserId,
                wxworkUserId: this.appInfo.userId,
                accountType: "qywx",
                accountOrgid: this.appInfo.corpId,
                appMark: qywxConst.appMark,
                appType: this.appInfo.appType, //应用类型：自建 or 第三方
                wxaction: beforeLoginUrlParam.wxaction,
              };
              url = util.addUrlParamFromObj(url, urlParam);
            } else {
              // 没有用户信息 去微信绑定 用微信版H5
              url = `${location.protocol}//${util.getHostFromUrl(
                this.appDetailInfoListSelected.url
              )}/h5/qywx/bind`;
              let urlParam = {
                // account: this.appInfo.openUserId,
                wxworkUserId: this.appInfo.userId,
                accountType: "qywx",
                accountOrgid: this.appInfo.corpId,
                appMark: qywxConst.appMark,
                appType: this.appInfo.appType, //应用类型：自建 or 第三方
              };
              url = util.addUrlParamFromObj(url, urlParam);
            }
            url = `${location.protocol}//${
              this.wxAuthSubDomain
            }.ttrushi.com/qc-webapp/wxapi.do?appid=${gzhAppId}&scope=snsapi_userinfo&wxauthcburl=${encodeURIComponent(
              url
            )}`;

            this.goWxAuthUrl = url;
            // 展示企微绑定微信页面
            this.pageName = this.pageEnum.selectWx;
            document.title = "企微绑定微信";
            wxsdk.init();
          }
        }
      });
    },
    clickSelectWxGoWxBind() {
      let url = this.goWxAuthUrl;
      if (this.global.isLoc) {
        console.log("拿到去微信的绑定链接，因在本地不做跳转");
        console.log("去微信打开链接", url);
      } else {
        location.href = url;
      }
    },
    clickSelectWxGoWxNext() {
      this.pageName = this.pageEnum.anotherWx;
      let gzhDomain = util.getHostFromUrl(this.appDetailInfoListSelected.url);
      let txt = `复制以下内容，在微信分身里面任意聊天对话框发送。然后依次点击下方链接。
1、绑定微信链接

https://${gzhDomain}/h5/qywx/bind?account=${this.appInfo.openUserId}&wxworkUserId=${this.appInfo.userId}&accountType=qywx&accountOrgid=${this.appInfo.corpId}&appMark=${qywxConst.appMark}&appType=${this.appInfo.appType}

2、关注公众号链接
https://${gzhDomain}/h5/qywx/wxaction?account=${this.appInfo.openUserId}&wxworkUserId=${this.appInfo.userId}&accountType=qywx&accountOrgid=${this.appInfo.corpId}&appMark=${qywxConst.appMark}&appType=${this.appInfo.appType}&wxaction=subscribe`;

      this.anotherWxCopyTxt = txt;
    },
    clickAnotherWxIntro() {
      wxsdk.wx.previewImage({
        current: "http://assets.rurushishi.com/yq-rs-make/qwauth/intro.jpeg", // 当前显示图片的http链接
        urls: ["http://assets.rurushishi.com/yq-rs-make/qwauth/intro.jpeg"], // 需要预览的图片http链接列表
      });
    },
    clickAnotherWxCopyTxt() {
      if (util.browser.versions.android) {
        var clipboard = new Clipboard("#copyBtn");
        clipboard.on("success", function (e) {
          util.showToast("复制成功");
          e.clearSelection();
        });
      } else {
        wxsdk.wx.setClipboardData({
          data: this.anotherWxCopyTxt, // 设置的
          success: function (res) {
            util.showToast("复制成功");
          },
          fail: function (res) {
            console.log("setClipboardData fail", res);
            util.showToast("复制失败");
          },
        });
      }
    },

    async canIUseCache() {
      if (this.$route.query.action) {
        return this.auth();
      }
      let callBackParams = {};
      Object.keys(this.cookieKeys).forEach((k) => {
        callBackParams[k] = Cookies.get(this.cookieKeys[k]);
      });
      console.log("callBackParams", callBackParams);
      if (
        !(
          callBackParams.openid &&
          callBackParams.passport &&
          callBackParams.appMark &&
          callBackParams.hasOwnProperty("appType") &&
          callBackParams.corpId &&
          callBackParams.gzhSubDomain &&
          callBackParams.gzhAppId &&
          callBackParams.gzhDomain &&
          callBackParams.qwUserId &&
          callBackParams.wxworkUserId
        )
      ) {
        return this.auth();
      }

      let resAppInfo = await api.getQwAppInfo({
        appMark: callBackParams.appMark,
      });
      console.log("resAppInfo", resAppInfo);
      if (!(resAppInfo.data && resAppInfo.data.appId)) {
        return this.auth();
      }
      qywxConst.suiteId = resAppInfo.data.appId;

      let resCorpSignature = await api.getCorpSignature({
        appMark: callBackParams.appMark,
        corpId: callBackParams.corpId,
        url: location.href,
        agentId: qywxConst.suiteId,
      });
      console.log("resCorpSignature", resCorpSignature);
      if (
        !(
          resCorpSignature.data.timestamp &&
          resCorpSignature.data.nonce &&
          resCorpSignature.data.signature
        )
      ) {
        return this.auth();
      }

      wx.config({
        beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
        appId: callBackParams.corpId, // 必填，企业微信的corpID
        timestamp: resCorpSignature.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: resCorpSignature.data.nonce, // 必填，生成签名的随机串
        signature: resCorpSignature.data.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
        jsApiList: [
          "onMenuShareAppMessage",
          "onMenuShareWechat",
          "onMenuShareTimeline",
          "openLocation",
          "getLocation",
          "previewImage",
        ], // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
      });
      let resCorpAgentSignature = await api.getCorpAgentSignature({
        appMark: callBackParams.appMark,
        corpId: callBackParams.corpId,
        url: location.href,
        agentId: qywxConst.suiteId,
      });
      console.log("resCorpAgentSignature", resCorpAgentSignature);
      if (
        !(
          resCorpAgentSignature &&
          resCorpAgentSignature.data &&
          resCorpAgentSignature.data.agentId &&
          resCorpAgentSignature.data.timestamp &&
          resCorpAgentSignature.data.nonce &&
          resCorpAgentSignature.data.signature
        )
      ) {
        return this.auth();
      }
      let that = this;
      wx.ready(function () {
        wx.agentConfig({
          corpid: callBackParams.corpId, // 必填，企业微信的corpid，必须与当前登录的企业一致
          agentid: resCorpAgentSignature.data.agentId, // 必填，企业微信的应用id （e.g. 1000247）
          timestamp: resCorpAgentSignature.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: resCorpAgentSignature.data.nonce, // 必填，生成签名的随机串
          signature: resCorpAgentSignature.data.signature, // 必填，签名，见附录-JS-SDK使用权限签名算法
          jsApiList: [
            "selectExternalContact",
            "getContext",
            "getCurExternalContact",
            "sendChatMessage",
            "shareToExternalContact",
          ], //必填，传入需要使用的接口名称
          success: (res) => {
            // 回调
            console.log("agentConfig success", res);
            let url = "";
            if (that.$route.query.url) {
              url = decodeURIComponent(that.$route.query.url);
            } else if (Cookies.get(that.cookieKeyBeforeLogin)) {
              let beforeLoginUrl = decodeURIComponent(
                Cookies.get(that.cookieKeyBeforeLogin)
              );
              let beforeLoginUrlParams = util.getParamFromUrl(beforeLoginUrl);
              if (beforeLoginUrlParams && beforeLoginUrlParams.url) {
                url = decodeURIComponent(beforeLoginUrlParams.url);
              }
            }
            if (url) {
              url = util.addUrlParamFromObj(url, callBackParams);
              location.href = url;
            } else {
              that.auth();
            }
          },
          fail: (res) => {
            console.log("agentConfig fail", res);
            that.auth();
          },
        });
      });
    },
    auth() {
      // 存当前的链接
      Cookies.set(
        this.cookieKeyBeforeLogin,
        encodeURIComponent(location.href),
        {
          expires: this.cookieExpires,
        }
      );
      // 设置授权后回调链接

      let authCallBackUrlParam = {
        appMark: qywxConst.appMark,
      };
      if (this.$route.query.action) {
        authCallBackUrlParam.action = this.$route.query.action;
      }
      let authCallBackUrl = util.addUrlParamFromObj(
        util.getUrlRemoveParams(location.href),
        authCallBackUrlParam
      );
      let postObj = {
        scope: "snsapi_userinfo",
        appMark: qywxConst.appMark,
        h5CallBackUrl: encodeURIComponent(authCallBackUrl),
        corpId: this.$route.query.corpId != 'undefined' ? this.$route.query.corpId : ''
      };
      api.getAuthUrl(postObj).then((res) => {
        if (res.code == 0) {
          if (this.global.isLoc) {
            console.log("getAuthUrl", res);
            console.log("拿到授权链接，因在本地不做跳转");
          } else {
            location.href = res.data;
          }
        }
      });
    },
  },
  async created() {
    /**
     * 功能说明：
     * 此页面是企微登录授权页面提供给需要授权的系统
     * 测试环境授权链接为 https://qywx.ruthus.com/qwh5/qywx/index?appMark=XXX&url=XXX&wxaction=XXX
     * 生产环境授权链接为 https://qyweb.gbtse.com/qwh5/qywx/index?appMark=XXX&url=XXX&wxaction=XXX
     * URL参数说明：
     * appMark 应用标识 第三方crm magicbox zxsl carcrm carmagicbox，自建 分配一个唯一名称（这个名称在数据库会对应企业id）。必填
     * url 授权成功后回调url需encodeURIComponent。非必填
     * wxaction 需要跳转到微信的操作， subscribe 去微信弹出关注二维码。非必填
     * action 需要执行的操作， unbundling 解绑微信且重新进入授权页面
     *
     * 回调url或者打开应用的默认url会带上：
     * openid
     * passport
     * appMark 企业微信应用标识
     * appType 0自建 1或者没有值是第三方
     * corpId 企业Id
     * qwUserId 企业微信用户id
     * gzhSubDomain 公众号对应的子域名 各个工程的api子域名需替换成这个
     * gzhAppId 公众号appid
     * gzhDomain 公众号域名
     *
     * 企微客户工具栏-百宝箱-H5内容点击转发icon弹出要发送的链接处理：
     * 如果域名/rd/是中转链接，把/rc/前面去掉只留后面的httpXXX
     * 域名不用做处理，原来是什么就是什么
     * 带上 appMark、appType、corpId、qwUserId、gzhSubDomain、gzhDomain、refereeopenid=自己的openid、rscuid=自己的openid
     *
     * 企微Tabbar工作台-销售员百宝箱-点击H5内容-素材详情的URL处理：
     * 企微Tabbar工作台-SCRM工作台-推广获客模块-百宝箱-点击H5内容-素材详情的URL处理（其实这个和上面是一样的）：
     * 企微Tabbar工作台-SCRM工作台-推广获客模块-我的内容-点击H5内容链接处理：
     * 企微Tabbar工作台-SCRM工作台-推广获客模块-粉丝受众/销售线索-点击头像-线上足迹-点击H5内容链接处理：
     * 企微Tabbar工作台-SCRM工作台-推广获客模块-我的名片链接处理：
     * 如果域名/rd/是中转链接，把/rc/前面去掉只留后面的httpXXX
     * 如果域名是qmyx.开头的替换为qywx.ruthus.com否则替换为qyweb.gbtse.com
     * 如果链接路径中有/h5/，则替换为/qwh5/
     * 带上 openid、passport、appMark、appType、corpId、qwUserId、gzhSubDomain、gzhDomain
     *
     * 备注：
     * 在企微下打开的链接也只能是测试环境qywx.ruthus.com或生产环境qyweb.gbtse.com
     *
     */
    if (!this.$route.query.appMark) {
      util.messageBox(`链接错误（-2002-01）`);
      return;
    }

    /**
     * 汽车业务，生产环境用 慧销车 huixiao，测试环境用 云中盘 cartest
     * 房产业务，生产环境用 原圈科技 rushi，测试环境用 很多奖 qmyx
     */
    if (
      this.$route.query.appMark == "carcrm" ||
      this.$route.query.appMark == "carmagicbox"
    ) {
      this.wxAuthSubDomain = "huixiao";
      if (location.host.indexOf(this.testDomain) > -1) {
        this.wxAuthSubDomain = "cartest";
      }
    } else {
      this.wxAuthSubDomain = "rushi";
      if (location.host.indexOf(this.testDomain) > -1) {
        this.wxAuthSubDomain = "qmyx";
      }
    }

    qywxConst.appMark = this.$route.query.appMark;
    // 设置存当前连接的cookie名
    this.cookieKeyBeforeLogin = `qw_before_login_url${qywxConst.appMark}`;
    // 授权回调会带上appInfo
    // appMark=crm&appInfo=%7B%22openUserId%22%3A%22woO3ZZCAAA35r7HROniYvWSLZXXhJ3UA%22,%22corpId%22%3A%22wwed9dac1a999baeac%22,%22appType%22%3A1,%22appDetailInfo%22%3A%5B%7B%22appId%22%3A%22wx01f0b018d4951434%22,%22appName%22%3A%22CRM%E5%B7%A5%E4%BD%9C%E5%8F%B0%22,%22domain%22%3A%22qmyx%22,%22url%22%3A%22https%3A%2F%2Fqmyx.putzip.com%2Fmarketies%2Fqwdesk%2Fpages%2Findex%2Fsale%22%7D%5D%7D
    if (this.$route.query.appInfo) {
      if (this.$route.query.errorCode != 0) return this.isAuthFail = true;
      let appInfo = JSON.parse(this.$route.query.appInfo);
      console.log("授权回调 appInfo", appInfo);
      this.appInfo = appInfo;

      api
        .getUserRelateWxUser({
          qwUserId: this.appInfo.userId,
          corpId: this.appInfo.corpId
        })
        .then(async (relateWxUserRes) => {
          // 如果找到了注册公众号的销售信息
          console.log("relateWxUserRes", relateWxUserRes);
          const { data } = await api.getUserRelateWxApps({ corpId: this.appInfo.corpId, appMark: this.$route.query.appMark || 'crm', userId: this.appInfo.userId})
          this.appDetailInfo = data.length ? data : []

          if (relateWxUserRes.data && relateWxUserRes.data.appId) {
            // 查询企微绑定的公众号列表
            if (this.appDetailInfo.length) {
              let gzhInfo = this.appDetailInfo.find(
                (item) => item.appId == relateWxUserRes.data.appId
              );
              if (gzhInfo) {
                this.appDetailInfoListSelected = gzhInfo;
                this.bindUserGzhInfo();
                return;
              }
            }
          }
          if (this.appInfo && this.appInfo.contactMsg) {
            // util.messageBox(this.appInfo.contactMsg).then(() => {
            //   this.loading = this.appInfo.contactMsg;
            // });
            document.getElementsByTagName("body")[0].style.overflow = "hidden";
            document.getElementsByTagName("body")[0].style.maxHeight = "100vh";
            this.pageName = this.pageEnum.experience;
            return;
          }
          // 有绑定的公众号信息
          if (
            this.appInfo.userId &&
            this.appInfo.corpId &&
            this.appDetailInfo &&
            this.appDetailInfo.length > 0
          ) {
            if (this.appDetailInfo.length == 1) {
              this.appDetailInfoListSelected = this.appDetailInfo[0];
              this.bindUserGzhInfo();
            } else {
              this.pageName = this.pageEnum.selectGzh;
            }
          } else {
            // alert("appInfo缺少appDetailInfo");
            // 没有绑定的公众号信息 可能是发给了另外一个企微上的人了。
            let beforeLoginUrl = "";
            let beforeLoginUrlParam = null;
            if (Cookies.get(this.cookieKeyBeforeLogin)) {
              beforeLoginUrl = decodeURIComponent(
                Cookies.get(this.cookieKeyBeforeLogin)
              );
              beforeLoginUrlParam = util.getParamFromUrl(beforeLoginUrl);
              if (beforeLoginUrlParam.url) {
                // 如果之前存的有回调链接则用之前存的回调链接
                let beforeLoginUrlParamUrlParam = util.getParamFromUrl(
                  decodeURIComponent(beforeLoginUrlParam.url)
                );
                let url = `${location.protocol}//${this.wxAuthSubDomain}.ttrushi.com/qc-webapp/wxapi.do?appid=${beforeLoginUrlParamUrlParam.gzhAppId}&scope=snsapi_userinfo&wxauthcburl=${beforeLoginUrlParam.url}`;
                location.href = url;
              } else {
                // 如果没有回调url
                this.pageName = this.pageEnum.experience;
                return;
              }
            } else {
              // 如果没有前面链接缓存
              this.pageName = this.pageEnum.experience;
              return;
            }
          }
        });
    } else {
      this.canIUseCache();
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="stylus">
.content {
  background: #F1F1F1;
  min-height: 100vh;
  font-size: 14px;
}

.loading {
  text-align: center;
  padding-top: 200px;
}

.authtips {
  text-align: center;

  .b1 {
    background-color: #ffffff;
    margin: 0 auto;
    width: 4.6rem;
    padding: 0.3rem 0;
    border-radius: 10px;
  }

  .b1 img {
    width: 4rem;
  }

  .b1 > div {
    font-size: 14px;
    color: #000000;
    font-weight: 600;
    padding-top: 0.1rem;
  }

  .b2 {
    margin-top: 1rem;
  }

  .b2txt0 {
    font-size: 14px;
  }

  .b2txt1 {
    font-size: 14px;
    margin-top: 0.2rem;
  }

  .b2txt1 > span {
    font-size: 14px;
    color: #0b7fe8;
    padding: 0 0.1rem;
  }

  .b2txt2 {
    font-size: 14px;
    margin-top: 0.2rem;
    color: #617086;
  }

  .b3 {
    font-size: 14px;
    margin-top: 0.3rem;
    position: fixed;
    bottom: 0.5rem;
    width: 100%;
    text-align: center;
  }

  .b3 > a {
    color: #0b7fe8;
  }

  .b4 {
    position: fixed;
    bottom: 1.5rem;
    display: flex;
    justify-content: center;
    width: 100%;
  }

  .b4btn1 {
    border: 1px solid #0b7fe8;
    padding: 0.3rem 0.4rem;
    border-radius: 5px;
    font-size: 14px;
    color: #0b7fe8;
  }
}

.selectgzh {
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    width: 80px;
    margin: 40px 0;
  }

  .select {
    width: 80%;
  }

  .next {
    margin-top: 80px;
    width: 80%;
    height: 40px;
    box-shadow: 0px 4px 18px 0px rgba(32, 47, 101, 0.26);
    border-radius: 20px;
    line-height: 40px;
    text-align: center;
    color: #ffffff;
    background: rgb(227, 227, 227);
  }

  .nextBlue {
    background: #5483F6;
  }
}

.selectWx {
  padding: 40px 20px;

  .title {
    font-family: PingFang SC;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.5px;
    color: #000000;
  }

  .defaultWx {
    margin-top: 20px;
    background: #FFFFFF;
    border-radius: 8px;
    padding: 10px;
    display: flex;
    line-height: 40px;

    .b1 {
      width: 50px;
      color: #000000;
      font-weight: 500;
    }

    .b3 {
      display: flex;
      flex: 1;
      flex-direction: row-reverse;

      .bind {
        width: 74px;
        height: 40px;
        background: #0B7FE8;
        border-radius: 6px;
        line-height: 40px;
        color: #fff;
        text-align: center;
      }
    }
  }

  .otherWx {
    margin-top: 20px;
    background: #FFFFFF;
    border-radius: 8px;
    padding: 10px;
    line-height: 40px;

    .ab1 {
      background: #FFFFFF;
      border-radius: 8px;
      padding: 20px;

      .title {
        color: #000000;
        font-size: 16px;
      }

      .abb {
        background: #F5F5F5;
        border-radius: 4px;
        margin-top: 10px;
        line-height: 36px;
        padding-left: 10px;
      }

      .abb1 {
        margin-top: 20px;
        color: #1890FF;
      }

      .abb3 {
        display: flex;
        justify-content: space-evenly;
        margin-top: 20px;

        div {
          text-align: center;

          img {
            width: 48px;
            height: 48px;
          }

          div {
            padding-top: 8px;
          }

          .div1 {
            padding-top: 15px;
          }

          .img2 {
            width: 51px;
            height: 55px;
          }
        }
      }
    }

    .b1 {
      display: flex;
      padding-left: 20px;

      .bb1 {
        width: 50px;
        color: #000000;
        font-weight: 500;
      }
    }

    .b2 {
      .next {
        margin: 10px auto 10px auto;
        width: 144px;
        height: 40px;
        border: 1px solid #1890FF;
        border-radius: 6px;
        line-height: 40px;
        color: #1890FF;
        text-align: center;
      }
    }
  }
}

.anotherWx {
  padding: 40px 20px 20px 20px;

  .b2 {
    text-align: center;
    color: #8C8C8C;
    margin: 20px 0;
  }

  .b3 {
    background: #FFFFFF;
    border-radius: 8px;
    padding: 20px;

    .title {
      display: flex;
      justify-content: space-between;

      .left {
        color: #000000;
        font-size: 16px;
      }

      .right {
        color: #0B7FE8;
        font-size: 12px;
      }
    }

    .txt1 {
      margin-top: 10px;
      color: #333333;
      line-height: 20px;
      text-align: justify;
    }

    .txt2 {
      margin-top: 10px;
      font-size: 10px;
      color: #BBBBBB;
      line-height: 13px;
      word-break: break-all;
      text-align: justify;
    }

    .copytxt {
      line-height: 40px;
      background: #0B7FE8;
      border-radius: 6px;
      width: 80%;
      margin: 20px auto 0 auto;
      color: #fff;
      text-align: center;
    }
  }
}

.auth-fail {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: #fff;
  padding-top: 80px;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  .fail-tip {
    margin-bottom: 20px;
    width: 204px;
    background: #E5E9F1;
    color: #617086;
    font-size: 16px;
    line-height: 20px;
    padding: 11px 2px 11px 14px;
    border-radius: 10px;
    position: relative;
    &::before {
      content: '';
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: -20px;
      width: 0px;
      height: 0px;
      border: 10px solid transparent;
      border-top-color: #E5E9F1;
    }
  }
  .fail-img {
    width: 140px;
    height: 140px;
  }
  .line {
    width: 90px;
    height: 10px;
    background: radial-gradient(50% 50% at 50% 50%, #D9D9D9 0%, rgba(228, 230, 232, 0) 100%);
    backdrop-filter: blur(7px);
  }
  .fail-desc {
    color: #A3AFBF;
    font-size: 14px;
    line-height: 20px;
    margin-top: 10px;
  }
}
.step-container {
  position: relative;
  height: 100vh;
  width: 100vw;
  background: url(https://assets.rurushishi.com/yq-rs-make/qwauth/bind-bg.png) top center no-repeat;
  background-size: 100%;
  box-sizing: border-box;
  padding-top: 100px;
  background-color: #ffffff;
  .bind-icon {
    margin: 0 auto;
    width: 285px;
    height: 113px;
    img {
      width: 285px;
    }
  }
  .bind-btn {
    margin: 32px auto 0 auto;
    width: 285px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    background: #0B7FE8;
    border-radius: 4px;
    font-weight: 400;
    color: #FFFFFF;
    font-size: 16px;
  }
  .bottom-text {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 50px;
    height: 24px;
    line-height: 24px;
    font-size: 14px;
    color: #001E4F;
    text-align: center;
    span {
      color: #0B7FE8;
      text-decoration:underline;
      text-underline-offset: 2px;
    }
  }
}
.step-anotherWx-container {
  position: relative;
  height: 100vh;
  width: 100vw;
  background: url(https://assets.rurushishi.com/yq-rs-make/qwauth/bind-bg.png) top center no-repeat;
  background-size: 100%;
  box-sizing: border-box;
  padding: 65px 18rpx 0 18rpx;
  background-color: #ffffff;
  .b3 {
    padding: 16px 16px;
    background: #FFFFFF;
    border-radius: 8px;
    .title {
      height: 16px;
      line-height: 16px;
      display: flex;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      .left {
        font-weight: 500;
        font-size: 16px;
        line-height: 16px;
        color: #000000;
      }
      .right {
        color: #0B7FE8;
        line-height: 16px;
        font-weight: 500;
        font-size: 12px;
      }
    }
    .txt1 {
      margin-top: 10px;
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      color: #333333;
    }
    .txt2 {
      margin-top: 14px;
      font-weight: 400;
      font-size: 10px;
      line-height: 12px;
      color: #BBBBBB;
    }
  }
  .copytxt {
    margin: 24px auto 0 auto;
    height: 44px;
    line-height: 44px;
    background: #0B7FE8;
    border-radius: 4px;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    text-align: center;
  }
}
</style>